import { CATEGORY_ICONS, isCategorySlug } from './categories';

/** Category icon in `currentColor`; renders nothing for an unknown slug. */
export function CategoryIcon({
	slug,
	className = 'size-4',
	strokeWidth = 2,
}: {
	slug: string;
	className?: string;
	strokeWidth?: number;
}) {
	if (!isCategorySlug(slug)) return null;
	const Icon = CATEGORY_ICONS[slug];
	return <Icon aria-hidden="true" className={className} strokeWidth={strokeWidth} />;
}
